module.exports = __webpack_public_path__ + "img/73.e8387ce5.png";